import { OnboardingState } from './choose-journey-types';

export function completeItem(state: OnboardingState, stepNo: number, itemNo: number) {
  if (!state.completedItems[stepNo]) {
    // add an entry for the items
    state.completedItems[stepNo] = {};
  }

  state.completedItems[stepNo][itemNo] = true;

  return state;
}
